import { useLogChangesTable } from "@/common/stores/logChangesTable";
import { LogChangeDiff } from "@/common/types/logs/change.type";
import { useEffect, useRef } from "react";

interface ChangesRowProps {
  id: string;
  field: string;
  diff: LogChangeDiff;
  col?: 'changes' | 'changes_before' | 'changes_after'
}

const ChangesRow = ({ id, field, diff, col }: ChangesRowProps) => {
  const { columnWidth, updateColumnWidth } = useLogChangesTable();

  const oldValueRef = useRef<HTMLDivElement>(null);
  const newValueRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (oldValueRef.current && oldValueRef.current.offsetWidth > columnWidth) {
      updateColumnWidth(oldValueRef.current.offsetWidth);
    }

    if (newValueRef.current && newValueRef.current.offsetWidth > columnWidth) {
      updateColumnWidth(newValueRef.current.offsetWidth);
    }

    if (oldValueRef.current) {
      oldValueRef.current.style.width = `${columnWidth}px`;
    }

    if (newValueRef.current) {
      newValueRef.current.style.width = `${columnWidth}px`;
    }
  }, [oldValueRef.current?.id, newValueRef.current?.id, columnWidth]);

  if (col === 'changes') {
    return (
      <div className="flex px-3 items-center h-[56px]">
        {field}
      </div>
    );
  }

  if (col === 'changes_before') {
    return (
      <div 
        ref={oldValueRef} 
        id={`${id}_${field}_0`} 
        className="log_cell px-3 flex items-center h-[56px] bg-[#FCCDCA33] min-w-max border-s border-s-white-200"
      >
        {diff[0] || '--'}
      </div>
    );
  }

  if (col === 'changes_after') {
    return (
      <div 
        ref={newValueRef} 
        id={`${id}_${field}_1`} 
        className="log_cell px-3 flex items-center h-[56px] bg-[#BEEFC233] min-w-max border-s border-s-white-200"
      >
        {diff[1]}
      </div>
    );
  }

  return null;
};

export default ChangesRow;
